var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard",class:_vm.class_},[_c('NetworkStatus'),_c('SystemError',{attrs:{"errors":_vm.errors}}),_c('div',{staticClass:"network-overlay"}),_c('Navbar'),_c('Content',{attrs:{"expanded":_vm.expanded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }